<div class="widget-icon" cdkDrag [cdkDragData]="data">
  <mat-icon class="drag-handler" cdkDragHandle [matBadge]="data.badge">
      {{data.icon}}
  </mat-icon>
  <div class="valdn-container">
  <select>
    <option>&lt;</option>
    <option>&gt;</option>
    <option>&lt;=</option>
    <option>&gt;=</option>
    <option>=</option>
  </select>
</div>>
